import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { violationFilterFields } from "~/widgets/Filter/ViolationFilter/model/fields";

export const ViolationFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => violationFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};
